// import unitMixin from "@/mixins/unitMixin";
import {mapGetters} from "vuex";
import {accessRight} from "@/lib/access-rights";

export default {
    computed: {
        ...mapGetters([
            "getAppUserUnits",

            "getUnits",
            "getUnitsByIds",
            "getSubUnitsIdsByIds",

            "getUnitsHasVideo",
            "getUnitsIdsIsFullLoad",
            "isUnitsLiteLoad",

            "getUnitsHwTypesByType",
            "isUnitsFullLoad",
        ]),
        isUnitFullLoad() {
            return this.isUnitsFullLoad || !!this.getUnitsIdsIsFullLoad.find(id => id == this.unitId)
        },
        isUnitLiteLoad() {
            return this.isUnitsLiteLoad
        },
        unit() {
            return this.getUnitsByIds[this.unitId]
        },
        hasVideo() {
            return !!this.unit?.video
        },
        unitVideo() {
            return this.unit?.video || {}
        },
        unitLiveVideoType() {
            return this.unitVideo['live-video-type']
        },
        unitName() {
            return this.unit?.name || ''
        },
        unitType() {
            return this.unit?.type || ''
        },
        unitXtype() {
            return this.unit?.xtype || ''
        },
        unitHwType() {
            return this.unit?.hw_type || ''
        },
        unitCameraType() {
            if (this.$isIntuit) return this.unit?.video?.cameratype || this.unit?.hw_type || ''
            return this.unit?.cameratype || ''
        },
        unitHwId() {
            return this.unit?.hw_id || ''
        },
        unitCoords() {
            return this.unit?.coords //ToDo fix format/name
        },
        unitMaxSpeed() {
            return this.unit?.max_speed > 0 ? this.unit?.max_speed : ''
            //return this.unit?.max_speed > 0 ? this.unit.max_speed+' '+this.getAppUserUnits.speed : ''
        },
        unitMaxSpeedWithUnits() {
            return this.unit?.max_speed > 0 ? this.unit.max_speed+' '+this.getAppUserUnits.speed : ''
        },
        unitPhoto() {
            return this.unit?.photo
        },
        isUnitAccessRight_edit() {
            let unitAccessRight = this.unit?.access_right || 0
            return unitAccessRight >= accessRight.edit
        },
        unitSubUnits() {
            return (this.getSubUnitsIdsByIds[this.unitId] || [])
                .map(uid => this.getUnitsByIds[uid])
        },

        unitHwTypeInfo() {
            return this.getUnitsHwTypesByType[this.unitHwType]
        },
        isStationaryObj() {
            return !!this.unitHwTypeInfo?.is_stationary_obj
        },
        isObd() {
            return !!this.unitHwTypeInfo?.is_obd
        },
        isChassis() {
            return this.unitType === 'chassis'
        },
        unitParentId() {
            return this.unit?.parent__id
        },
        unitMainRouteTemplate() {
            let routeParams = this.routeMeta?.getUnitDefaultRouteParams(this.unitId);
            return routeParams?.params?.template
        }
    }
}